import { isEmptyArray } from 'formik'
import GAME_EVENT_FORM_BROADCAST_FIELDS from './gameEventFormBroadcastFields'
import LIVESTREAM_TYPE_OPTIONS from './livestreamTypeOptions'
import isObjectEmptyHelper from '../helpers/isObjectEmptyHelper'
import { STREAM_FEATURES, supports } from './streamTypeCapabilities'

// Business rules for gameEventForm livestream fields (It's used for data parse and not form validation)
const LIVESTREAM_FIELDS_VALIDATIONS = {
  [GAME_EVENT_FORM_BROADCAST_FIELDS.IS_RECORD]: (values) =>
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_BROADCAST] ||
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_RECORD],

  [GAME_EVENT_FORM_BROADCAST_FIELDS.TYPE]: (values) =>
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_BROADCAST] ||
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_RECORD],

  [GAME_EVENT_FORM_BROADCAST_FIELDS.LOAD_RECENT_SETUPS]: (values) =>
    (values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_BROADCAST] ||
      values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_RECORD]) &&
    supports(values[GAME_EVENT_FORM_BROADCAST_FIELDS.TYPE], STREAM_FEATURES.COURT_LOGOS),

  [GAME_EVENT_FORM_BROADCAST_FIELDS.STREAM_DESTINATION]: (values) =>
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_BROADCAST] &&
    isObjectEmptyHelper(values[GAME_EVENT_FORM_BROADCAST_FIELDS.EVENT_YT_CONFIG]),

  [GAME_EVENT_FORM_BROADCAST_FIELDS.EVENT_YT_CONFIG]: (values) =>
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_BROADCAST] &&
    !isObjectEmptyHelper(values[GAME_EVENT_FORM_BROADCAST_FIELDS.EVENT_YT_CONFIG]),

  [GAME_EVENT_FORM_BROADCAST_FIELDS.IS_LIVESTREAM_TYPE_FULL]: (values) =>
    (values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_BROADCAST] ||
      values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_RECORD]) &&
    supports(values[GAME_EVENT_FORM_BROADCAST_FIELDS.TYPE], STREAM_FEATURES.COURT_LOGOS),

  [GAME_EVENT_FORM_BROADCAST_FIELDS.IS_LIVESTREAM_TYPE_LITE]: (values) =>
    (values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_BROADCAST] ||
      values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_RECORD]) &&
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.TYPE] === LIVESTREAM_TYPE_OPTIONS.LIVESTREAM_LITE,

  [GAME_EVENT_FORM_BROADCAST_FIELDS.UPLOADED_MEDIAS]: (values) =>
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_BROADCAST] &&
    supports(values[GAME_EVENT_FORM_BROADCAST_FIELDS.TYPE], STREAM_FEATURES.SPONSOR_VIDEOS) &&
    values.teams &&
    !isEmptyArray(values.teams),

  [GAME_EVENT_FORM_BROADCAST_FIELDS.STREAM_DESTINATION_2]: (values) =>
    values[GAME_EVENT_FORM_BROADCAST_FIELDS.IS_ADDITIONAL_STREAM_DESTINATION_ADDED],
}

export default LIVESTREAM_FIELDS_VALIDATIONS
